__turbopack_context__.v({
  "drawerContent": "drawer-shop-card-module-scss-module__IoSmvG__drawerContent",
});
